const DEFAULT_HOSTS = [
  "store.atomicpay.com.br",
  "fallback.atomicpay.store",
  "domains.atomicpay.store",
  "atomicpay.store",
  "www.atomicpay.store",
  "localhost",
  "127.0.0.1",
];

export function platformHosts() {
  const extra = String(import.meta.env.VITE_STOREFRONT_PLATFORM_HOSTS || "")
    .split(",")
    .map((value) => value.trim().toLowerCase())
    .filter(Boolean);
  return new Set([...DEFAULT_HOSTS, ...extra]);
}

export function isPlatformStorefrontHost(hostname) {
  const host = String(hostname || "").toLowerCase();
  if (platformHosts().has(host)) return true;
  return host.endsWith(".localhost");
}
